import { FaUsersBetweenLines } from 'react-icons/fa6';
import {Link} from 'react-router-dom'
import {FaWpforms} from 'react-icons/fa'

type CustomCardProps = {
  title?: string;
  description?: string;
  icon?: string;
  url: string ;
}

const CustomCard = ({ title, description, icon, url }:CustomCardProps) => {
    return (
      <Link
        to={url}
      >
          <div  className="card card-custom shadow justify-content-center align-items-center ">
            <div className="card-body d-block p-10 ">
              <div className='symbol symbol-24px me-5 d-flex mb-3 justify-content-center align-items-center'>
                  <span className='symbol-label bg-light-warning'>
                    <i className='ki-duotone ki-abstract-18 fs-2x text-warning'>
                      <FaWpforms />
                    </i>
                  </span>
                </div>
              <h3 className="card-title">{title}</h3>
          </div>
        </div>
      </Link>
    );
}

export default CustomCard;